const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);
export const normalizeBlockProps = (value) => isPlainObject(value) ? value : {};
const isValidPluginId = (value) => /^[a-zA-Z0-9._-]+$/.test(value);
const resolveRuntimeMode = (value) => {
    if (value === 'storefront-runtime')
        return 'storefront-runtime';
    if (value === 'preview-only')
        return 'preview-only';
    if (value === 'admin-only')
        return 'admin-only';
    return null;
};
const resolveStorefrontLayout = (value) => {
    if (value === 'contained')
        return 'contained';
    if (value === 'full-bleed')
        return 'full-bleed';
    if (value === 'raw')
        return 'raw';
    return null;
};
export const resolveBlockContract = (block) => {
    const pluginIdCandidate = typeof block.pluginId === 'string' ? block.pluginId.trim() : '';
    const pluginId = pluginIdCandidate && isValidPluginId(pluginIdCandidate) ? pluginIdCandidate : null;
    const runtimeMode = resolveRuntimeMode(block.runtimeMode) ?? (pluginId ? 'preview-only' : null);
    const storefrontLayout = resolveStorefrontLayout(block.storefrontLayout);
    const configVersionCandidate = Number(block.configVersion);
    const configVersion = Number.isInteger(configVersionCandidate) && configVersionCandidate > 0
        ? configVersionCandidate
        : undefined;
    return {
        pluginId,
        ...(runtimeMode ? { runtimeMode } : {}),
        ...(configVersion ? { configVersion } : {}),
        ...(storefrontLayout ? { storefrontLayout } : {}),
    };
};
export const normalizeBlockTree = (input) => {
    const ensureUniqueSiblingIds = (blocks) => {
        const seen = new Map();
        return blocks.map((block) => {
            const seenCount = seen.get(block.id) ?? 0;
            seen.set(block.id, seenCount + 1);
            if (seenCount === 0)
                return block;
            return {
                ...block,
                id: `${block.id}__${seenCount}`,
            };
        });
    };
    const normalizeChildren = (children) => {
        if (!Array.isArray(children))
            return [];
        return ensureUniqueSiblingIds(children.map((entry) => normalize(entry)).filter((entry) => Boolean(entry)));
    };
    const normalize = (value) => {
        if (!isPlainObject(value))
            return null;
        const id = typeof value.id === 'string' && value.id.trim() ? value.id.trim() : null;
        const type = typeof value.type === 'string' && value.type.trim() ? value.type.trim() : null;
        if (!id || !type)
            return null;
        const contract = resolveBlockContract({
            type,
            pluginId: value.pluginId,
            runtimeMode: value.runtimeMode,
            configVersion: value.configVersion,
            storefrontLayout: value.storefrontLayout,
        });
        const children = normalizeChildren(value.children);
        return {
            id,
            type,
            props: normalizeBlockProps(value.props),
            ...(contract.pluginId ? { pluginId: contract.pluginId } : {}),
            ...(contract.runtimeMode ? { runtimeMode: contract.runtimeMode } : {}),
            ...(contract.configVersion ? { configVersion: contract.configVersion } : {}),
            ...(contract.storefrontLayout ? { storefrontLayout: contract.storefrontLayout } : {}),
            ...(children.length ? { children } : {}),
        };
    };
    if (!Array.isArray(input))
        return [];
    return ensureUniqueSiblingIds(input.map((entry) => normalize(entry)).filter((entry) => Boolean(entry)));
};
